import { AnalysisType } from 'projects/dop-ordering/src/public-api';

export class CommercialItem {
  sequence?: number;
  name?: string;
  code: string;
  testBundleCode?: string;
  testBundleDisplayName?: string;
  invoiceableItemParentCode: string;
  type?: AnalysisType;
  price?: number;
  membertests?: any[];
  sampleCodes?: any[];
  key?: string;
  preparationTests?: string[];
  isMandatory?: boolean;
  monographCode?: string;
  compendiumCode?: string;
  monographName?: string;
  compendiumName?: string;
  comment?: string;
  executionNumber?: number;
}
